<template>
  <EmptyStatePlaceHolder header="" :description="$t('InsuranceAPI.EmptyPages.PAGE_UNDER_CONSTRUCTION_DESC')" />
</template>
<script>
import EmptyStatePlaceHolder from '@/components/EmptyStatePlaceholder.vue'
export default {
  data () {
    return {
      imageEmptyCoversUrl: require(`@/assets/img/${process.env.VUE_APP_NODE_ENV_API}/empty-covers.svg`)
    }
  },
  components: {
    EmptyStatePlaceHolder
  }
}
</script>
